let base = window._env_.VUE_APP_RECRUIT_HOST
export const getPositionTable = params => {
  return axios.post(`${base}/query_position`, params)
}
export const topPosition = id => {
  return axios.post(`${base}/top_position_` + id)
}
export const releasePosition = id => {
  return axios.post(`${base}/release_position_` + id)
}
export const deletePosition = id => {
  return axios.post(`${base}/delete_position_` + id)
}
export const batchDeletePosition = ids => {
  return axios.post(`${base}/batch_delete_position`, ids)
}
export const batchTopPosition = ids => {
  return axios.post(`${base}/batch_top_position`, ids)
}
export const batchReleasePosition = ids => {
  return axios.post(`${base}/batch_release_position`, ids)
}
export const getPostionForm = id => {
  return axios.get(`${base}/position_` + id)
}
export const modifyPostion = params => {
  return axios.post(`${base}/modify_position_` + params.id, params)
}
export const editPostionOptions = params => {
  return axios.get(`${base}/edit_position_options`)
}
export const uploadPositionFile = params => {
  return axios.post(`${base}/upload_position_file`, params)
}
export const getBatchJobTable = params => {
  return axios.post(`${base}/query_batch_job`, params)
}
export const offlinePosition = id => {
  return axios.post(`${base}/offline_position_` + id)
}
export const batchOfflinePosition = params => {
  return axios.post(`${base}/batch_offline_position`, params)
}
export const batchJobSample = params => {
  return axios.get(`${base}/batch_job_sample`)
}
export const batchJobDown = id => {
  return axios.get(`${base}/batch_job_down_` + id)
}
export const batchJobError = id => {
  return axios.get(`${base}/batch_job_error_` + id)
}
export const forceOfflinePosition = id => {
  return axios.post(`${base}/force_offline_position_` + id)
}
export const lockPosition = id => {
  return axios.post(`${base}/lock_position_` + id)
}
export const unlockPosition = id => {
  return axios.post(`${base}/unlock_position_` + id)
}
export const passAuditPosition = id => {
  return axios.post(`${base}/pass_audit_position_` + id)
}
export const failAuditPosition = params => {
  return axios.post(`${base}/fail_audit_position_` + params.position_id, params)
}



// WEBPACK FOOTER //
// ./src/views/position/position.api.js